import type { AlertColor, AlertProps } from '@mui/material';
import { Alert } from '@mui/material';

import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{ paletteColor: AlertColor }>()
  .create(({ theme, paletteColor }) => {
    return {
      root: {
        borderRadius: '20px',
      },
      bordered: {
        border: `1px solid ${theme.palette[paletteColor].main}`,
      },
    };
  });

interface Props extends AlertProps {
  bordered?: boolean;
}

export const Or2Alert = ({
  bordered = false,
  children,
  className,
  severity = 'info',
  ...other
}: Props) => {
  const { classes, cx } = useStyles({
    paletteColor: severity,
  });

  return (
    <Alert
      className={cx(classes.root, className, {
        [classes.bordered]: bordered,
      })}
      severity={severity}
      {...other}
    >
      {children}
    </Alert>
  );
};
